module.exports = __webpack_public_path__ + "static/GreatRoomDining-5daae04e0cfa427597ee5091583c0b02.jpg";